export type PromotionsDto = Readonly<{
  page: number;
  size: number;
  type: PromotionsType;
  externalId?: string;
  // restaurantId: string;
  // internalStatus: PromotionStatusEnum;
}>;

export enum PromotionsType {
  DISCOUNT = 'DISCOUNT',
  COUPON = 'COUPON',
  PROMOCODE = 'PROMOCODE',
  NEWS = 'NEWS',
  UNKNOWN = 'UNKNOWN',
}

export type PromotionType = {
  promotionPageFileId: number | null;
  ticketLikeImageFileId: number | null;
  verticalImageFileId: number | null;
  description: string;
  descriptionPart1?: string;
  descriptionPart2?: string;
  linkName?: string;
  linkSource?: string;
  buttonName?: string;
  buttonSource?: string;
  type: PromotionsType;
  id: number;
  name: string;
  internalStatus: PromotionStatusEnum;
  sortOrder: number | null;
  startedAt: Date;
  endsAt: Date | null;
  externalId: string;
  isShownOnMainPage: boolean;
};

export type PromotionDataType = PromotionType & {
  code: string;
  isForAllProducts: boolean;
  isShowOnMainPage: boolean;
  descriptionPart1?: string;
  descriptionPart2?: string;
  linkName?: string;
  linkSource?: string;
  buttonName?: string;
  buttonSource?: string;
};

export enum PromotionStatusEnum {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}
